<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 md8 offset-md2>
        <v-card class="mt-3 elevation-4">
          <v-card-title class="deep-orange lighten-1">
            <div class="white--text headline">Agradecimento Familiar</div>
          </v-card-title>
          <v-card-text v-if="prazoTrue">

            <v-form v-model="validfamiliar" ref="formfamiliar">
              <v-text-field label="Título do Agradecimento Familiar" v-model="agradecimentos.familiar.titulo" :rules="tituloRules" :counter="40" required @blur="submitfamiliar"></v-text-field>
              <v-text-field label="Nomes dos Familiares" v-model="agradecimentos.familiar.nomes" :rules="nomesRules" :counter="80" @blur="submitfamiliar"></v-text-field>
              <v-text-field label="Texto do Agradecimento" v-model="agradecimentos.familiar.texto" :rules="textoRules" :counter="1000" multi-line required @blur="submitfamiliar"></v-text-field>
            </v-form>
          </v-card-text>

          <v-card-text class="preview grey lighten-3">
            <h2>{{agradecimentos.familiar.titulo}}</h2>
            <h3>{{agradecimentos.familiar.nomes}}</h3>
            <p>
              <pre>{{agradecimentos.familiar.texto}}</pre>
            </p>
          </v-card-text>

          <v-card-actions v-if="prazoTrue" class="preview grey lighten-1">
            <span>Atenção não fazemos correção ortográfica</span>
            <v-spacer></v-spacer>
            <v-btn @click="submitfamiliar" color="primary">
              Enviar
            </v-btn>

            <v-snackbar color="success" top :timeout="2000" v-model="familiarok">
              Salvo
              <v-btn dark flat @click.native="familiarok = false">Fechar</v-btn>
            </v-snackbar>
          </v-card-actions>
        </v-card>

        <v-card class="mt-3 elevation-4">
          <v-card-title class="deep-orange lighten-1">
            <div class="white--text headline">Agradecimento Pessoal</div>
          </v-card-title>
          <v-card-text v-if="prazoTrue">
            <v-form v-model="validpessoal" ref="formpessoal">
              <v-text-field label="Título do Agradecimento Pessoal" v-model="agradecimentos.pessoal.titulo" :rules="tituloRules" :counter="40" @blur="submitpessoal" required></v-text-field>
              <v-text-field label="Texto do Agradecimento" v-model="agradecimentos.pessoal.texto" :rules="textoRules" :counter="1200" @blur="submitpessoal" multi-line required></v-text-field>

              <v-snackbar color="success" top :timeout="2000" v-model="pessoalok">
                Salvo
                <v-btn dark flat @click.native="pessoalok = false">Fechar</v-btn>
              </v-snackbar>

            </v-form>
          </v-card-text>

          <v-card-text class="preview grey lighten-3">
            <h2>{{agradecimentos.pessoal.titulo}}</h2>
            <p>
              <pre>{{agradecimentos.pessoal.texto}}</pre>
            </p>
          </v-card-text>

          <v-card-actions v-if="prazoTrue" class="preview grey lighten-1">
            <span>Atenção não fazemos correção ortográfica</span>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="submitpessoal">Enviar
            </v-btn>
          </v-card-actions>

        </v-card>

        <v-card class="mt-3 elevation-4">
          <v-card-title class="deep-orange lighten-1">
            <div class="white--text headline">Encarte</div>
          </v-card-title>
          <v-card-text v-if="prazoTrue">
            <v-form v-model="validencarte" ref="formencarte">
              <v-text-field label="Texto do Encarte" v-model="agradecimentos.encarte.texto" :rules="encarteRules" :counter="1000" @blur="submitencarte" multi-line required></v-text-field>

              <v-snackbar color="success" top :timeout="2000" v-model="encarteok">
                Salvo
                <v-btn dark flat @click.native="encarteok = false">Fechar</v-btn>
              </v-snackbar>

            </v-form>
          </v-card-text>
          <v-card-text class="preview grey lighten-3">
            <p>
              <pre>{{agradecimentos.encarte.texto}}</pre>
            </p>
          </v-card-text>

          <v-card-actions v-if="prazoTrue" class="preview grey lighten-1">
            <span>Atenção não fazemos correção ortográfica</span>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="submitencarte">Enviar
            </v-btn>
          </v-card-actions>

        </v-card>
      </v-flex>
    </v-layout>

  </v-container>
</template>


<script>
import moment from "moment";
moment.locale("pt-BR");
export default {
  data() {
    return {
      user: {},
      emailkey: "",
      prazo: "",
      prazoTrue: true,
      projeto: "",
      agradecimentos: {
        familiar: {
          titulo: "",
          nomes: "",
          texto: ""
        },
        pessoal: {
          titulo: "",
          texto: ""
        },
        encarte: {
          texto: ""
        }
      },
      pessoalok: false,
      familiarok: false,
      encarteok: false,
      validfamiliar: false,
      validpessoal: false,
      validencarte: false,
      tituloRules: [
        v => !!v || "Título é obrigatório",
        v =>
          (v && v.length <= 40) || "O Título tem que ter menos de 40 caracteres"
      ],
      nomesRules: [
        v => v.length <= 80 || "Os nomes tem que ter menos de 80 caracteres"
      ],
      textoRules: [
        v => !!v || "Texto é obrigatório",
        v =>
          (v && v.length <= 1200) ||
          "O agradecimento tem que ter menos de 1200 caracteres"
      ],
      encarteRules: [
        v => !!v || "Texto é obrigatório",
        v =>
          (v && v.length <= 1000) ||
          "O agradecimento tem que ter menos de 1000 caracteres"
      ]
    };
  },
  mounted() {
    this.$auth.onAuthStateChanged(user => {
      if (user) {
        this.user = user;
        this.emailkey = user.email.replace(/[.]/g, ",");
        const ref = this.$db.ref(`users/${this.emailkey}`);
        ref.once("value", snap => {
          this.projeto = snap.val().projeto.atual;
          this.agradecimentos = snap.val().projeto.projetos[
            this.projeto
          ].dados.agradecimentos;
          let prazo = snap.val().projeto.projetos[this.projeto].prazo;
          this.prazo = moment(prazo, "DD/MM/YYYY").format("DD/MM/YYYY");
          this.prazoTrue = moment(prazo, "DD/MM/YYYY").isAfter(moment());
          this.faltamdias = Math.ceil(
            moment(prazo, "DD/MM/YYYY").diff(moment(), "days", true)
          );
        });
      } else {
        this.$router.push("/login");
      }
    });
  },
  methods: {
    submitfamiliar() {
      // regex para arrumar espacos depois e antes de pontuação
      this.agradecimentos.familiar.titulo = this.agradecimentos.familiar.titulo
        .replace(/([,.!?;:])/g, "$1 ")
        .replace(/ {2,}/g, " ")
        .replace(/ ([,.!?;:])/g, "$1")
        .trim();
      this.agradecimentos.familiar.nomes = this.agradecimentos.familiar.nomes
        .replace(/([,.!?;:])/g, "$1 ")
        .replace(/ {2,}/g, " ")
        .replace(/ ([,.!?;:])/g, "$1")
        .trim();
      this.agradecimentos.familiar.texto = this.agradecimentos.familiar.texto
        .replace(/([,.!?;:])/g, "$1 ")
        .replace(/ {2,}/g, " ")
        .replace(/ ([,.!?;:])/g, "$1")
        .trim();

      if (this.$refs.formfamiliar.validate()) {
        const agradecimentofamiliar = this.agradecimentos.familiar;
        let updates = {};
        updates[
          `users/${this.emailkey}/projeto/projetos/${
            this.projeto
          }/dados/agradecimentos/familiar`
        ] = agradecimentofamiliar;
        updates[
          `projetos/${this.projeto}/formandos/${
            this.emailkey
          }/agradecimentos/familiar`
        ] = agradecimentofamiliar;
        return this.$db
          .ref()
          .update(updates)
          .then(
            () => {
              this.familiarok = true;
            },
            error => {
              console.log(error);
            }
          );
      } else {
        this.snack = true;
        this.snackText = "Falha na validação";
        this.snackColor = "error";
      }
    },
    submitpessoal() {
      // regex para arrumar espacos depois e antes de pontuação
      this.agradecimentos.pessoal.titulo = this.agradecimentos.pessoal.titulo
        .replace(/([,.!?;:])/g, "$1 ")
        .replace(/ {2,}/g, " ")
        .replace(/ ([,.!?;:])/g, "$1")
        .trim();
      this.agradecimentos.pessoal.texto = this.agradecimentos.pessoal.texto
        .replace(/([,.!?;:])/g, "$1 ")
        .replace(/ {2,}/g, " ")
        .replace(/ ([,.!?;:])/g, "$1")
        .trim();
      if (this.$refs.formpessoal.validate()) {
        const agradecimentopessoal = this.agradecimentos.pessoal;
        let updates = {};
        updates[
          `users/${this.emailkey}/projeto/projetos/${
            this.projeto
          }/dados/agradecimentos/pessoal`
        ] = agradecimentopessoal;
        updates[
          `projetos/${this.projeto}/formandos/${
            this.emailkey
          }/agradecimentos/pessoal`
        ] = agradecimentopessoal;
        return this.$db
          .ref()
          .update(updates)
          .then(
            () => {
              this.pessoalok = true;
            },
            error => {
              console.log(error);
            }
          );
      } else {
        this.snack = true;
        this.snackText = "Falha na validação";
        this.snackColor = "error";
      }
    },
    submitencarte() {
      // regex para arrumar espacos depois e antes de pontuação
      this.agradecimentos.encarte.texto = this.agradecimentos.encarte.texto
        .replace(/([,.!?;:])/g, "$1 ")
        .replace(/ {2,}/g, " ")
        .replace(/ ([,.!?;:])/g, "$1")
        .trim();
      if (this.$refs.formencarte.validate()) {
        const agradecimentoencarte = this.agradecimentos.encarte;
        let updates = {};
        updates[
          `users/${this.emailkey}/projeto/projetos/${
            this.projeto
          }/dados/agradecimentos/encarte`
        ] = agradecimentoencarte;
        updates[
          `projetos/${this.projeto}/formandos/${
            this.emailkey
          }/agradecimentos/encarte`
        ] = agradecimentoencarte;
        return this.$db
          .ref()
          .update(updates)
          .then(
            () => {
              this.encarteok = true;
            },
            error => {
              console.log(error);
            }
          );
      } else {
        this.snack = true;
        this.snackText = "Falha na validação";
        this.snackColor = "error";
      }
    }
  }
};
</script>

<style lang="stylus">
.preview {
  h2 {
    font-size: 28px;
    font-weight: 700;
    line-height: 1.2;
  }

  h3 {
    font-size: 24px;
    line-height: 1.2;
  }

  p {
    font-size: 18px;

    pre {
      white-space: pre-wrap;
      word-wrap: break-word;
      font-family: inherit;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/AppMainAgradecimentos.vue